export const atendimentoKeys = {
  atendimento: ['atendimento'] as const,
  porId: (id: string) => [...atendimentoKeys.atendimento, id] as const,
  atendimentoAtivo: () => [...atendimentoKeys.atendimento, 'ativo'] as const,
  criarAtendimento: () => [...atendimentoKeys.atendimento, 'criar'] as const,
  encerrarAtendimento: () => [...atendimentoKeys.atendimento, 'encerrar'] as const,
  ultimosAtendimentos: () => [...atendimentoKeys.atendimento, 'ultimos-atendimentos'] as const,
  ultimosAtendimentosChile: () => [...atendimentoKeys.atendimento, 'ultimos-atendimentos-chile'] as const,
  detalhesChile: (atendimentoId: string) => [...atendimentoKeys.atendimento, 'detalhes-chile', atendimentoId] as const,
}
